__turbopack_context__.v({
  "embedShield": "DiscoveryMediaBlock-module__bfJvAq__embedShield",
  "hoverScrim": "DiscoveryMediaBlock-module__bfJvAq__hoverScrim",
  "lightboxBackdrop": "DiscoveryMediaBlock-module__bfJvAq__lightboxBackdrop",
  "lightboxClose": "DiscoveryMediaBlock-module__bfJvAq__lightboxClose",
  "lightboxMediaHost": "DiscoveryMediaBlock-module__bfJvAq__lightboxMediaHost",
  "media": "DiscoveryMediaBlock-module__bfJvAq__media",
  "mediaAsset": "DiscoveryMediaBlock-module__bfJvAq__mediaAsset",
  "mediaAssetLightbox": "DiscoveryMediaBlock-module__bfJvAq__mediaAssetLightbox",
  "mediaFrame": "DiscoveryMediaBlock-module__bfJvAq__mediaFrame",
  "mediaScaleIn": "DiscoveryMediaBlock-module__bfJvAq__mediaScaleIn",
  "mediaSlot": "DiscoveryMediaBlock-module__bfJvAq__mediaSlot",
  "mediaWrapper": "DiscoveryMediaBlock-module__bfJvAq__mediaWrapper",
  "playButton": "DiscoveryMediaBlock-module__bfJvAq__playButton",
  "playIcon": "DiscoveryMediaBlock-module__bfJvAq__playIcon",
  "playOverlay": "DiscoveryMediaBlock-module__bfJvAq__playOverlay",
  "section": "DiscoveryMediaBlock-module__bfJvAq__section",
  "title": "DiscoveryMediaBlock-module__bfJvAq__title",
});
